const ACCESS_TOKEN_KEY = 'token';
const REFRESH_TOKEN_KEY = 'rft';

/**
 * 获取access_token
 * @return {string|undefined}
 */
const getAccessToken = () => {
  const accessToken = localStorage.getItem(ACCESS_TOKEN_KEY);
  return accessToken ?? undefined;
};

/**
 * 设置access_token
 */
const setAccessToken = (token) => {
  localStorage.setItem(ACCESS_TOKEN_KEY, token);
};

/**
 * 获取refresh_token
 * @return {string|undefined}
 */
const getRefreshToken = () => {
  const refreshToken = localStorage.getItem(REFRESH_TOKEN_KEY);
  return refreshToken ?? undefined;
};

/**
 * 设置refresh_token
 */
const setRefreshToken = (rft) => {
  localStorage.setItem(REFRESH_TOKEN_KEY, rft);
};

const isTokenPermanent = () => {
  const permanentValue = localStorage.getItem(ACCESS_TOKEN_KEY);
  return typeof permanentValue === 'string';
};

/**
 * 清理access_token
 */
const clearAccessToken = () => {
  localStorage.removeItem(ACCESS_TOKEN_KEY);
};

/**
 * 清理localStorage
 */
const clearAccess = () => {
  localStorage.clear();
};

/**
 * 清理refresh_token
 */
const clearRefreshToken = () => {
  localStorage.removeItem(REFRESH_TOKEN_KEY);
};

/**
 * 获取用户名
 */
const getUserName = () => localStorage.getItem('userName');

/**
 * 设置用户名
 */
const setUserName = (userName) => {
  localStorage.setItem('userName', userName);
};

export {
  getAccessToken,
  setAccessToken,
  getRefreshToken,
  setRefreshToken,
  clearAccessToken,
  clearRefreshToken,
  isTokenPermanent,
  getUserName,
  setUserName,
  clearAccess,
};
